function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import isObject from 'lodash/isObject';
import stylesVariables from 'common/_variables';
import { lightenDarkenColor } from 'helpers/color';
import Button from 'components/Form/Button';
import XIcon from 'svg/x.svg';
import ErrorIcon from 'svg/error-mark.svg';
import { isMobileDisplayMode as isMobileDisplayModeSelector } from 'modules/App/selectors';
const Alert = ({ id, idx = 0, type, message, messageValues = {}, actions, isCollapsed = false, onClose, onToggleCollapse })=>{
    const isMobileDisplayMode = useSelector(isMobileDisplayModeSelector);
    const getStyle = ()=>{
        if (!isCollapsed || isMobileDisplayMode) {
            return null;
        }
        const color = stylesVariables[`brand-${type}`];
        return {
            marginLeft: `${8 * idx}px`,
            marginRight: `${8 * idx}px`,
            backgroundColor: lightenDarkenColor(color, -25 * idx)
        };
    };
    const clickAction = (evt, actionFn)=>{
        evt.stopPropagation();
        actionFn();
        if (onClose) onClose();
    };
    const close = (evt)=>{
        evt.stopPropagation();
        if (onClose) onClose();
    };
    const renderIcon = ()=>{
        if (!isMobileDisplayMode || type !== 'error') return null;
        return /*#__PURE__*/ _jsx(ErrorIcon, {});
    };
    const renderActions = ()=>{
        if (!actions) {
            return null;
        }
        return actions.map((action)=>/*#__PURE__*/ _jsx(Button, {
                className: "btn--sm btn--white alert_button",
                isDisabled: action.isDisabled,
                onClick: (evt)=>clickAction(evt, action.action),
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, action.message))
            }, `alert-button-${action.message.id}-${id}`));
    };
    const renderCloseBtn = ()=>{
        if (!onClose || isMobileDisplayMode) return null;
        return /*#__PURE__*/ _jsx(XIcon, {
            className: "alert_close",
            onClick: close
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "alertContainer",
        children: /*#__PURE__*/ _jsxs("div", {
            className: `alert alert-${type}`,
            style: getStyle(),
            role: "alert",
            onClick: onToggleCollapse,
            onKeyDown: null,
            "data-testid": `alert-${id}`,
            children: [
                renderIcon(),
                /*#__PURE__*/ _jsx("div", {
                    className: "alert_content",
                    children: isObject(message) && message.id ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, message), {
                        values: messageValues
                    })) : message
                }),
                renderActions(),
                renderCloseBtn()
            ]
        })
    });
};
export default Alert;
